module.exports = __webpack_public_path__ + "img/magnifying_glass.a567c220.svg";